import { Box, IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Image3D } from '~/domain/patient/image3d';
import { ImageRegistration } from '~/domain/patient/patient';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import ImageDetails from './ImageDetails';
import BlendImagePicker from './ImagePicker/BlendImagePicker';
import ImageTitle from './ImageTitle';
import { CircleMinus } from 'lucide-react';

type BlendImageProps = {
    image: Image3D;
    blendableImages: ImageRegistration[];
    onChange: (
        image: Image3D,
        registration: RigidRegistration | undefined
    ) => void;
};

export default function BlendImage({
    image,
    blendableImages,
    onChange,
}: BlendImageProps) {
    const { removeEnvironmentBlendImage } = useViewportEnvironment();
    return (
        <Box px={2}>
            <Box
                display="flex"
                position="relative"
                justifyContent="space-between"
            >
                <ImageTitle
                    label={<FormattedMessage id="blendImage" />}
                    image={image}
                />
                <Box display="flex" gap={0.5} alignItems="center">
                    {blendableImages.length > 0 && (
                        <BlendImagePicker
                            blendableImages={blendableImages}
                            onChange={onChange}
                        />
                    )}
                    <Box>
                        <Tooltip title={<FormattedMessage id="disableBlend" />}>
                            <IconButton
                                color="primary"
                                size="small"
                                onClick={() => removeEnvironmentBlendImage()}
                            >
                                <CircleMinus size={12} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
            <ImageDetails image={image} />
        </Box>
    );
}
